import cardDragStartHandler from '../Drag/cardDragStartHandler';
import Logger from '../../../../../../../../../utility/services/Logger';

export default (params) => {
  const {
    e,
    noDrag,
    nodeProps: {
      editor,
      node: { key: nodeKey },
    },
    collapse,
    setCollapse,
    setSnackBar,
    setDrag,
  } = params;

  e.stopPropagation(); // stop propagating to org drag start

  if (noDrag) {
    e.preventDefault();
    setDrag(false);
    return;
  }

  try {
    editor.blur(); // to prevent default insertion

    const {
      value: { document: editorDocument },
    } = editor;
    const organization = editorDocument.getParent(nodeKey);
    const {
      nodes: { size: organizationNodesSize },
    } = organization;

    if (organizationNodesSize === 2) {
      e.preventDefault();
      return;
    }

    cardDragStartHandler({
      e,
      editor,
      collapse,
      nodeKey,
      dragType: 'ROLE',
      setCollapse,
      setSnackBar,
    });
  } catch (err) {
    Logger.LogError(err);
    setSnackBar('error');
  }
};
